import { FilePlus2, GitBranch, ShieldCheck, Users } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import { paths } from '@/app/router/paths'
import type { PortalRole } from '@/features/auth/types'

export type NavItem = {
  label: string
  to: string
  icon: LucideIcon
  /** Omit to show the item to every signed-in role. */
  roles?: PortalRole[]
}

export type NavSection = {
  label: string
  items: NavItem[]
}

export const navigation: NavSection[] = [
  {
    label: 'Sales',
    items: [
      { label: 'Pipeline', to: paths.projects.pipeline, icon: GitBranch },
      { label: 'New project', to: paths.projects.new, icon: FilePlus2 },
    ],
  },
  {
    label: 'Delivery',
    items: [{ label: 'People', to: paths.people.roster, icon: Users }],
  },
  {
    label: 'Administration',
    items: [{ label: 'Portal access', to: paths.admin.users, icon: ShieldCheck, roles: ['Administrator'] }],
  },
]
